import Content from "../Content/Content";
import Title from "../Title/Title";
import CardHoverPoint from "../CardHoverPoint/CardHoverPoint";
import React from "react";
import {IIconCards} from "../../redux/initState/InterfacesState";
import {connect, MapDispatchToProps, MapStateToProps, WithStore} from "../../redux/services/Imports";

interface Props {
  heightLazy: number | null;
  iconCards: IIconCards
}

export const BlockIconCards = ({heightLazy = null, iconCards}: Props) => {
  if (!iconCards.title && (!iconCards.items || !iconCards.items.length)) {
    return <></>;
  }
  return (
    <Content
      heightLazy={heightLazy}
      padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
      block={
        <>
          <Title center title={iconCards.title} />
          <div className="page-return-documents__grid-4">
            {iconCards.items.map((item, i) => (
              <CardHoverPoint {...item} key={i} />
            ))}
          </div>
        </>
      }
    />
  );
}

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockIconCards));
